import React from 'react';
import StandardThumb from '../../../DeviationViews/Thumb/Standard';
import { MeasuredContainer, MeasuredCookieType, measuredDefaultSize, } from '../../../Measured';
import s from './MobileThumbList.scss';
var MobileThumbList = function (_a) {
    var deviations = _a.deviations;
    return (React.createElement(MeasuredContainer, { cookieType: MeasuredCookieType.DEVIATION_MOBILE_SIDEBAR, cookieDim: 'width', defaultSize: measuredDefaultSize, listenOnWindow: true, limitToParentWidth: true, measureWindow: true }, function (_a) {
        var container = _a.container;
        return (React.createElement(React.Fragment, null, deviations.slice(0, 5).map(function (deviation) { return (React.createElement(StandardThumb, { key: deviation.deviationId, deviation: deviation, width: container ? container.width : measuredDefaultSize.mobile.width, height: 239, className: s['thumb'] })); })));
    }));
};
MobileThumbList.displayName = 'MobileThumbList';
export default MobileThumbList;
//# sourceMappingURL=MobileThumbList.js.map